import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getTopRelationshipCountChanges';

export const getTopRelationshipCountChanges = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
